import { render, staticRenderFns } from "./DetalheValorVencidoForm.vue?vue&type=template&id=3a625253&scoped=true&"
import script from "./DetalheValorVencidoForm.vue?vue&type=script&lang=js&"
export * from "./DetalheValorVencidoForm.vue?vue&type=script&lang=js&"
import style0 from "./DetalheValorVencidoForm.vue?vue&type=style&index=0&id=3a625253&scoped=true&lang=css&"
import style1 from "./DetalheValorVencidoForm.vue?vue&type=style&index=1&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a625253",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VDivider,VIcon,VRow})
